import { RefObject, memo } from "react";

import TableSettings from "ds/components/Table/Settings";
import TableHead from "ds/components/Table/Head";
import { getHeadColumnKey } from "ds/components/Table/Head/helpers";
import { selectVisibleColumns } from "ds/components/Table/store/useTableStore/selectors";

import IacManagementTableHeadColumn from "./Column";
import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../../../ListLayout/types";
import { showTableSettingsDrawer } from "./Drawer";
import useIacTableStore from "../useIacTableStore";

type IacManagementTableHeadProps = {
  tableRef: RefObject<HTMLDivElement | null>;
};

const IacManagementTableHead = memo(({ tableRef }: IacManagementTableHeadProps) => {
  const columns = useIacTableStore(selectVisibleColumns);
  const isFirstColumnPinned = useIacTableStore((state) => state.isFirstColumnPinned);

  return (
    <TableHead>
      {columns.map((column, i) => {
        return (
          <IacManagementTableHeadColumn
            key={getHeadColumnKey(column)}
            column={column}
            // FYI: the current implementation supports only one pinned column and automatically moves to the first position
            stickyLeft={i === 0 && isFirstColumnPinned}
            stickyRight={column.id === IAC_MANAGEMENTS_TABLE_COLUMNS.ACTIONS}
            tableRef={tableRef}
          >
            {column.id === IAC_MANAGEMENTS_TABLE_COLUMNS.ACTIONS && (
              <TableSettings title="IaC management settings" onPress={showTableSettingsDrawer} />
            )}
          </IacManagementTableHeadColumn>
        );
      })}
    </TableHead>
  );
});

IacManagementTableHead.displayName = "IacManagementTableHead";

export default IacManagementTableHead;
